// extracted by mini-css-extract-plugin
export default {"container":"table_container__oN0Ml","header":"table_header__S3vwg"};